var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode2Red(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16H38V0H30V16ZM0 16H0.9375V0H0V16ZM2.8125 16H4.6875V0H2.8125V16ZM6.5625 16H8.4375V0H6.5625V16ZM10.3125 16H12.1875V0H10.3125V16ZM14.0625 16H15.9375V0H14.0625V16ZM17.8125 16H19.6875V0H17.8125V16ZM21.5625 16H23.4375V0H21.5625V16ZM25.3125 16H27.1875V0H25.3125V16ZM29.0625 16H30V0H29.0625V16Z",
    fill: "#D11A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode2Red);
export default __webpack_public_path__ + "static/media/barcode2-red.15977004b1a45241f6d23a1e8e081386.svg";
export { ForwardRef as ReactComponent };